export default __webpack_public_path__ + "static/media/comet-tiamat.92478f22.gif";